import { useRef, useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { useLoginAlert } from '@/contexts/LoginAlertContext'
import { useClickOutside } from '@/hooks/useClickOutside'
import { AddPurchaseForm } from './AddPurchaseForm'

/**
 * "Adicionar compra" do cabeçalho, a partir de `md`.
 *
 * Abre um campo para colar o link do anúncio já comprado — é o caminho para
 * registrar compras de produtos que não estão listados no site. Em telas
 * estreitas o cabeçalho não mostra este botão: a mesma ação vira item do menu
 * sanduíche (ver UserMenu).
 */
export function AddPurchasePopover() {
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const { isAuthenticated } = useAuth()
  const { show: showLoginAlert } = useLoginAlert()

  useClickOutside(containerRef, () => setOpen(false), open)

  function toggle() {
    if (!isAuthenticated) {
      showLoginAlert()
      return
    }
    setOpen((current) => !current)
  }

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        aria-haspopup="dialog"
        className="flex items-center whitespace-nowrap text-[13px] font-semibold text-white transition-opacity hover:opacity-80"
      >
        Adicionar compra
      </button>

      {open && (
        <div
          role="dialog"
          aria-label="Adicionar compra pelo link"
          className="absolute right-0 top-[calc(100%+0.9rem)] z-50 w-72 rounded bg-surface p-2 shadow-pop animate-[slide-down_0.18s_ease-out] sm:w-80"
        >
          <AddPurchaseForm autoFocus onDone={() => setOpen(false)} />
        </div>
      )}
    </div>
  )
}
